import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { StatDisplaySkeleton } from 'app/agriculture/components/StatDisplay/StatDisplaySkeleton';

export function LocationDisplaySkeleton() {
    const { device } = useContext(DeviceDetailContext);
    const { locationOverride } = device;

    return (
        <ContentBox.Section heading="Device Location" disableDivider>
            <SimpleGrid className="LocationDisplay" columns={3}>
                <StatDisplaySkeleton />
                <StatDisplaySkeleton />
                <StatDisplaySkeleton />
                {!locationOverride ? (
                    <>
                        <StatDisplaySkeleton />
                        <StatDisplaySkeleton />
                        <StatDisplaySkeleton />
                    </>
                ) : null}
            </SimpleGrid>
        </ContentBox.Section>
    );
}
